import styled from "styled-components";

export const FormSubmissionError = styled.p.attrs({ role: "alert" })`
  color: #e02948;
`;
